/**
 * Représente le mode du composant sélecteur de période.
 */
export enum ModeSelecteurPeriode {
	JOUR = 'JOUR',
	SEMAINE = 'SEMAINE',
}